var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"discover"},[_c('LandingPage',{staticClass:"landingPage"}),_c('DiscoverPage'),_c('FooterPage',{staticClass:"footerPage"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }